<template>
  <!--pages/settlementDetail/index.wxml-->
  <div class="scroll-view" v-scroll-bottom="loadMoreData">
      <div class="settlement-div">
          <order-list mode="settlement" :order-list="orderList" :has-more="hasMore"></order-list>
      </div>
      <Toast type="loading" v-if="showToast">
        {{ message }}
      </Toast>
  </div>
</template>
<script>
import OrderList from '@/components/list/OrderList.vue'
import { getSettlementDetail } from '@/services/order'

export default {
  name: 'SettlementDetailView',
  components: {
    OrderList
  },
  data() {
    return {
      orderList: [],
      hasMore: false,
      settlementId: '',
      page: 1
    }
  },
  created() {
    this.settlementId = this.$route.params.settlementId
    this.getDetailList()
  },
  methods: {
    getDetailList() {
      this.$showToast({
          type: 'loading',
          toastMessage: '正在加载数据...',
          duration: 2000 
      })
      getSettlementDetail({ page: this.page, limit: 10, settlementId: parseInt(this.settlementId) }).then(res => {
          if(res.data.items) {
              res.data.items.forEach(it => {
                  this.orderList.push(it)
              })
              this.hasMore = res.data.hasMore
          }
          
      }).catch(() => {
      })
    },
    loadMoreData() {
      this.page++
      this.getDetailList()
    }
  }
}
</script>
<style scoped>
.settlement-div{
    padding: 0 var(--len10);
}
</style>